import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Message module.
 */
export const MESSAGE_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/message',
    labelKey: 'Message.main',
    icon: '/assets/tablerIcons/outline/mail.svg',
    moduleId: 23,
    groupLabelKey: 'MenuRoutes.group.messageViews'
  },
  {
    path: '/message/my-post',
    labelKey: 'Message.myPost',
    icon: '/assets/tablerIcons/outline/inbox.svg',
    moduleId: 23,
    groupLabelKey: 'MenuRoutes.group.messageViews'
  },
  {
    path: '/message/mailing-list',
    labelKey: 'Message.mailingList',
    icon: '/assets/tablerIcons/outline/users.svg',
    moduleId: 23,
    groupLabelKey: 'MenuRoutes.group.messageMailing'
  },
  {
    path: '/message/mailing-list-report',
    labelKey: 'Message.mailingListReport',
    icon: '/assets/tablerIcons/outline/report.svg',
    moduleId: 23,
    groupLabelKey: 'MenuRoutes.group.messageMailing'
  }
];
